export const makeCdnUrl = (url: string, isKey = false) => {
  return url && url?.includes("s3")
    ? "https://d372ebr33sbljd.cloudfront.net/" +
        url.split("/").slice(3).join("/")
    : isKey
    ? "https://d372ebr33sbljd.cloudfront.net/" + url
    : url;
};
